import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
// Preloader
const Preloader = React.lazy(() => import("./diagnosis/components/layouts/Preloader"));

// Pages
const Home = React.lazy(() => import("./diagnosis/components/pages/Home"));
const AboutUs = React.lazy(() => import("./diagnosis/components/pages/AboutUs"));
const TechIntroduction = React.lazy(() => import("./diagnosis/components/pages/TechIntroduction"));
const ProductIntroduction = React.lazy(() => import("./diagnosis/components/pages/ProductIntroduction"));
const ProductCCDD = React.lazy(() => import("./diagnosis/components/pages/ProductCCDD"));
const Servicetwo = React.lazy(() => import("./diagnosis/components/pages/Servicetwo"));
const Contact = React.lazy(() => import("./diagnosis/components/pages/Contact"));
const Login = React.lazy(() => import("./diagnosis/components/pages/Login"));
const Register = React.lazy(() => import("./diagnosis/components/pages/Register"));
const Servicedetailstwo = React.lazy(() => import("./diagnosis/components/pages/Servicedetailstwo"));
const PersonalCenter = React.lazy(() => import("./diagnosis/components/pages/PersonalCenter"));
const Password=React.lazy(()=>import("./diagnosis/components/pages/Password"));
const Result=React.lazy(()=>import("./diagnosis/components/pages/Result"));
const AdminUserManage=React.lazy(()=>import('./diagnosis/components/pages/AdminUserManage'));
const EcgData=React.lazy(()=>import("./diagnosis/components/pages/EcgData"));
import locale from 'antd/locale/zh_CN';
function App() {
  return (
    <ConfigProvider
    locale={locale}
    theme={{
      token:{
        colorPrimary:'#0384CE',
      }
    }}
    >
      <Router>
        <Suspense fallback={<div></div>}>
          {/* <Preloader /> */}
          <Routes>
            {/* // 静态界面(zhanghan todo) */}
            <Route path="/" Component={Home} />
            <Route path="/product" Component={ProductIntroduction} />
            <Route path="/product/ccdd" Component={ProductCCDD} />
            <Route path="/tech" Component={TechIntroduction} />
            <Route path="/about" Component={AboutUs} />
            <Route path="/contact-us" Component={Contact} />

            {/* // 在线测试(wangerke todo) */}
            <Route path="/heartmind-ol" Component={Servicetwo} />

            {/* // 旧页面 */}
            <Route path="/services" Component={Servicetwo} />
            <Route path="/login" Component={Login} />
            <Route path="/register" Component={Register} />
            <Route path="/service-details-two" Component={Servicedetailstwo} />
            <Route path="/personal-center" Component={PersonalCenter} />
            <Route path="/password" Component={Password} />
            <Route path="/result" Component={Result}/>
            <Route path="/admin-user-manage" Component={AdminUserManage}></Route>
            <Route path="/ecg-data" Component={EcgData}></Route>
          </Routes>
        </Suspense>
      </Router>
     </ConfigProvider>

  );
}

export default App;
